import { styled } from '@mui/material/styles';
import { Paper } from '@mui/material';

export const Wrapper = styled(Paper)(() => ({
    width: '100%',
    top: 0,
    position: 'sticky',
    height: '100dvh',
    padding: '1rem 1rem 1rem 0',
}));

export const Container = styled(Paper, {
    shouldForwardProp: (prop) => prop !== 'isDisabled',
})<{ isDisabled?: boolean }>(({ isDisabled, theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    backgroundColor: theme.palette.background.default,
    overscrollBehavior: 'contain',
    padding: theme.spacing(2),
    borderRadius: 24,
    position: 'relative',
    '&:after': {
        content: isDisabled ? '""' : 'none',
        display: 'block',
        position: 'absolute',
        zIndex: theme.zIndex.modal,
        inset: 0,
        background: theme.palette.background.default,
        opacity: '0.7',
    },
}));
